// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Palau from '../_raw/flag/icon_flag_palau.png';

export default () => <img src={Palau} alt="Palau" />;
